// RecentContractsCard.jsx — 상황판 '최근 계약' 칸 (2026-10-19, bigCards/renderTables.jsx 에서 옮김)
//   본사 위젯(recent_contracts_mobile)과 회사별·통합 계약 위젯이 같은 칸을 쓴다. groups = recentContractGroups.js 결과.
import React from 'react';
import { FileText, FileSignature } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { UnifiedCard } from './UnifiedCard';
import { accentBorder } from './widgetAccent';

export function RecentContractsCard({ code, title = '최근 계약', groups, accentOverride, sortableId, onClick }) {
  const recentTotal = (groups || []).reduce((s, g) => s + (g.contracts?.length || 0), 0);
  return (
    <UnifiedCard code={code} title={title} icon={FileText} accent="indigo" accentOverride={accentOverride} size="L" sortableId={sortableId} watermarkIcon={FileSignature} onClick={onClick}>
      {/* 헤더 카운트 — 내일 방문 위젯과 동일(text-xl accent + 단위) */}
      <div className="flex items-baseline justify-end gap-1 mb-2">
        <span className="text-xl font-black tabular-nums leading-none text-indigo-700 dark:text-indigo-300">{recentTotal}</span>
        <span className="text-[10px] font-bold text-[var(--text-sub)] uppercase tracking-wider">건 계약</span>
      </div>
      <div className={cn('border-t mx-1 my-1.5', accentBorder(accentOverride || 'indigo') || '')} />
      {/* 오늘(왼쪽)/어제(오른쪽) 좌우 배치. 각 계약: 1줄 상담자·마케터·상호,
          2줄 상품×계약장수(전체 표시) + 오른쪽에 서비스 상품×장수(더 작게, 라벨 없음). */}
      <div className="grid grid-cols-2 gap-3">
        {groups.map((group) => (
          <div key={group.date} className="min-w-0">
            <div className="flex items-baseline gap-1 mb-1">
              <span className="text-[10px] font-bold text-[var(--text-sub)]">{group.label}</span>
              <span className="text-[9px] font-normal text-[var(--text-muted)]">({group.date.slice(5)})</span>
              <span className="text-[9px] font-bold text-emerald-700 dark:text-emerald-300 ml-auto">{group.contracts.length}건</span>
            </div>
            {group.contracts.length === 0 ? (
              <div className="text-[9px] text-[var(--text-muted)] pl-1">없음</div>
            ) : (
              <div className="flex flex-col gap-1.5">
                {group.contracts.map((row) => {
                  const items   = Array.isArray(row.contract_items) ? row.contract_items : [];
                  const fmt     = (i) => `${i.ticketTypeName || '?'}${i.quantity > 1 ? `×${i.quantity}` : ''}`;
                  const normal  = items.filter((i) => !i.isService);
                  const service = items.filter((i) => i.isService);
                  const prodLabel = normal.length ? normal.map(fmt).join(', ') : '-';
                  const svcLabel  = service.length ? service.map(fmt).join(', ') : '';
                  const people = [row.user_name, row.sales_person_name].filter(Boolean).join('·');
                  return (
                    <div key={row.id} className="min-w-0 leading-tight">
                      <div className="flex items-baseline gap-1 min-w-0">
                        <span className="text-[10px] font-bold text-[var(--text)] truncate flex-shrink-0 max-w-[120px]">{people || '-'}</span>
                        {row.company_name && (
                          <span className="text-[8px] text-[var(--text-muted)] truncate min-w-0">· {row.company_name}</span>
                        )}
                      </div>
                      <div className="flex items-baseline gap-1.5 pl-1 min-w-0">
                        <span className="text-[9px] font-semibold text-blue-600 dark:text-blue-300 break-words min-w-0">{prodLabel}</span>
                        {svcLabel && (
                          <span className="text-[8px] text-[var(--text-muted)] whitespace-nowrap flex-shrink-0">{svcLabel}</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    </UnifiedCard>
  );
}
